import gql from 'graphql-tag';
import { currentAppUser, settings, groups, group } from '@manakin/app-core/graphQlHelpers';

export const GQL_UPDATE_APP_USER = gql`
	mutation updateAppUser (
		$id: ID!
        $school: Long
	) {
		updateAppUser(
			input: {
				id: $id
                school: $school
			}
		) {
            user {
                ${currentAppUser}
            }
		}
	}
`;

export const GQL_CURRENT_APP_USER_VALIDATE = gql`
	query currentAppUser {
		currentAppUser {
			id
			roles {
				name
			}
			licenses {
				code
			}
		}
	}
`;

export const GQL_CURRENT_APP_USER = gql`
    query currentAppUser {
        currentAppUser {
            ${currentAppUser}
        }
    }
`;

export const GQL_CURRENT_CMS_USER = gql`
	query currentCmsUser {
		currentCmsUser {
			id
		}
	}
`;

export const GQL_VALID_LICENSE_CHECK = gql`
	query validLicenseCheck {
		validLicenseCheck {
			hasValidLicense
		}
	}
`;

export const GQL_LOGOUT = gql`
	mutation logoutApp {
		logoutApp
	}
`;

export const GQL_LOGOUT_CMS = gql`
	mutation logoutCms {
		logoutCms
	}
`;

export const GQL_RESET_PASSWORD = gql`
	mutation forgotPassword($email: String!) {
		forgotPasswordCms(input: { email: $email }) {
			result
		}
	}
`;

export const GQL_LOGIN_TOKEN = gql`
    mutation loginTokenApp($token: String!) {
        loginTokenApp(input: { token: $token }) {
            user {
                ${currentAppUser}
            }
        }
    }
`;

export const GQL_LOGIN_CMS = gql`
	mutation loginCms($email: String!, $password: String!) {
		loginCms(input: { email: $email, password: $password }) {
			mfa
			mfaDataUri
			showQr
			user {
				id
				locale {
					code
				}
				roles {
					privileges {
						id
					}
				}
			}
		}
	}
`;

export const GQL_CHANGE_PASSWORD = gql`
	mutation changePassword($password: String!, $token: String!) {
		changePassword(input: { password: $password, token: $token }) {
			user {
				id
				roles {
					privileges {
						id
					}
				}
			}
		}
	}
`;

export const GQL_LOGIN_APP = gql`
    mutation loginApp($email: String!, $password: String!) {
        loginApp(input: { email: $email, password: $password }) {
            mfa
            mfaDataUri
            showQr
            user {
                ${currentAppUser}
            }
        }
    }
`;

export const GQL_REGISTER_APP_USER = gql`
	mutation registerAppUser (
		$email: String!
		$password: String
		$firstName: String
		$middleName: String
		$lastName: String
		$gender: Gender
		$dateOfBirth: String
		$phonenumber: String
		$school: Long
		$schoolClasses: [ID]
		$registerCode: String
		$registerType: String
		$sendVerifyMail: Boolean
	) {
		registerAppUser(
			input: {
				email: $email
				password: $password
				firstName: $firstName
				middleName: $middleName
				lastName: $lastName
				gender: $gender
				dateOfBirth: $dateOfBirth
				phonenumber: $phonenumber
				school: $school
				schoolClasses: $schoolClasses
				registerCode: $registerCode
				registerType: $registerType
				sendVerifyMail: $sendVerifyMail
			}) {
			user {
				id
				fullName
			}
		}
	}
`;


export const GQL_FETCH_APP_USER = gql`
    query appUser($id: ID!) {
        appUser(id: $id) {
            ${currentAppUser}
        }
    }
`;

export const GQL_FETCH_SETTINGS = gql`
	query settingss {
		settings {
			settings {
				name
				value
				file {
					id
					url
				}
			}
		}
	}
`;

export const GQL_FETCH_GROUPS = gql`
	query groups($page: Int!, $pagesize: Int!, $search: String, $filter: GroupFilter) {
		groups(
			page: $page
			pagesize: $pagesize
			search: $search
			filter: $filter
		) {
			${groups}
		}
	}
`;

export const GQL_FETCH_REGISTRATION_GROUPS = gql`
	query registrationGroups($page: Int!, $pagesize: Int!, $filter: RegistrationGroupFilter) {
		registrationGroups(page: $page, pagesize: $pagesize, filter: $filter) {
			id
			name
			visibleForRegistration
		}
	}
`;

export const GQL_FETCH_GROUP = gql`
    query group($id: ID!) {
        group(id: $id) {
            ${group}
        }
    }
`;

export const GQL_VERIFY_MFA = gql`
	mutation verifyMfa($input: VerifyCodeInput!) {
		verifyMfa(input: $input)
	}
`;

export const GQL_FETCH_LOCALES = gql`
	query {
		locales {
			locales {
				code
				title
				enabled
			}
		}
	}
`;

export const GQL_RESET_MFA_TOKEN = gql`
	mutation resetMfaByToken($token: String!) {
		resetMfaByToken(input: { token: $token })
	}
`;

export const GQL_FETCH_ORGANISATION = gql`
	query organisation($id: ID!) {
		organisation(id: $id) {
			id
			schools {
				id
				name
			}
		}
	}
`;

export const GQL_FETCH_SCHOOLS = gql`
	query schools($page: Int!, $pagesize: Int!, $filter: GroupFilter) {
		groups(page: $page, pagesize: $pagesize, filter: $filter) {
			groups {
				id
				name
				type
			}
		}
	}
`;

export const GQL_FETCH_PRODUCTS = gql`
	query webshopProducts {
		webshopProducts(page: 0, pagesize: 99) {
			id
			name
			priceCents
			showInWebshop
			firstUspText
			secondUspText
		}
	}
`;

export const GQL_PAY = gql`
	mutation pay($input: PayInput) {
		pay(input: $input) {
			result
			orderId
		}
	}
`;

export const GQL_SIMPLE_ORDER = gql`
	query simpleOrder($id: ID!) {
		simpleOrder(id: $id) {
			paymentUrl
			status
			transactionId
		}
	}
`;

export const GQL_ACQUIRE_LICENSES = gql`
	mutation acquireLicenses($unlimited: Boolean!) {
		acquireLicenses(input: { unlimited: $unlimited }) {
			result
		}
	}
`;

export const GQL_FETCH_APP_USER_FOR_STORE = gql`
	query {
		currentAppUser {
			id
			firstName
			lastName
			licenses {
				code
				validUntil
				licenseGroup {
					product {
						program {
							id
							name
						}
					}
				}
			}
			schoolClasses {
				id
				name
				street
				buildingNumber
				zipCode
				city
				country
				schools {
					id
					organisations {
						id
						mainOrganisation {
							id
							name
						}
					}
				}
			}
			group {
				id
				name
			}
			roles {
				id
				name
			}
			userDataCbd {
				trainingMandatory2016
				trainingMandatory2017
				trainingMandatory2018
				trainingMandatory2019
				trainingMandatory2020
				trainingMandatory2021
				trainingMandatory2022
				trainingMandatory2023
				trainingMandatory2024
                trainingMandatory2025
                trainingMandatory2026
                trainingMandatory2027
                trainingMandatory2028
                trainingMandatory2029
                trainingMandatory2030
				function
			}
		}
	}
`;

export const GQL_CHECK_STATUS = gql`
	mutation idealStatus($transactionId: String!) {
		idealStatus(input: { transactionId: $transactionId }) {
			transaction {
				status
			}
		}
	}
`;

export const GQL_FETCH_SERVER_INFO = gql`
	query serverInfo {
		serverInfo {
			currentYear
		}
	}
`;
